import React from "react";
import PropTypes from "prop-types";
import {
  TextInput,
  SelectInput,
  RadioGroupField,
  PhoneNumberInput
} from "components/form";
import { useFormikContext, Field } from "formik";
import useTranslate from "hooks/use-translate-language";
import { isValidPhone, isValidZip, normalizePhone } from "utils/misc";
import FormElement from "./form-elements";
import { STATES } from "utils/enum";

const PhysicianForm = ({ physician, questions }) => {
  const { values, setFieldValue } = useFormikContext();
  const translate = useTranslate();

const convertStateToAbbreviation = (stateName) => {
  if (!stateName) return '';
  
  // If it's already an abbreviation (2 characters), return as-is
  if (stateName.length === 2) return stateName.toUpperCase();
  
  const stateOption = STATES.find(state => 
    state.text.toLowerCase() === stateName.toLowerCase()
  );
  
  return stateOption ? stateOption.value : '';
};

  const physician_change_question = questions.find(
    q => q.id === "physician_change"
  );

  const misc_physician_quesitons = questions.filter(
    x => x.category == "Physician" && x.id != "physician_change"
  );

  React.useEffect(() => {
    if (values.questions?.physician_change === false) {
      setFieldValue("physician", {
        ...physician,
        phone: normalizePhone(physician?.phone),
        address: {
          ...physician?.address,
          state: convertStateToAbbreviation(physician?.address?.state)
        }
      });
    }
  }, [values.questions?.physician_change]);

  if (!physician_change_question) {
    return null;
  }
  const disabled = !values.questions?.physician_change;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        paddingTop: 15
      }}
    >
      {misc_physician_quesitons.map(question => (
        <FormElement key={question.id} {...question} />
      ))}
      <Field
        component={RadioGroupField}
        name="questions.physician_change"
        label={physician_change_question.text}
        value={values.questions.physician_change}
        options={[
          { value: true, text: "Yes" },
          { value: false, text: "No" }
        ]}
      />
      <div style={{ height: 20, marginBottom: 10 }}>
        {!disabled && (
          <sub style={{ color: "#444" }}>{translate("enterInformation")}</sub>
        )}
      </div>
      <div style={{ margin: 5, padding: 10 }}>
        <div
          style={{
            display: "grid",
            gap: 5,
            gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))"
          }}
        >
          <TextInput
            name="physician.name"
            label={translate("myCurrentPhysician")}
            style={{ marginBottom: 20 }}
            disabled={disabled}
          />
          <TextInput
            name="physician.npi"
            label="NPI #"
            style={{ marginBottom: 20 }}
            disabled={disabled}
            type="number"
          />
        </div>
        <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))",
              gap: 5
            }}
          >
            <TextInput
              name="physician.address.street_address"
              label={translate("streetAddress")}
              style={{ marginBottom: 10 }}
              disabled={disabled}
            />
            <TextInput
              name="physician.address.city"
              label={translate("city")}
              style={{ marginBottom: 10 }}
              disabled={disabled}
            />
            <TextInput
              name="physician.address.zip"
              type="number"
              label={translate("zip")}
              style={{ marginBottom: 10 }}
              disabled={disabled}
              validate={isValidZip}
            />
            <SelectInput
              name="physician.address.state"
              label={translate("state")}
              options={STATES}
              // style={{ marginBottom: 20 }}
              style={{ marginTop: 10, marginBottom: 10 }}
              disabled={disabled}
            />
          </div>
          <PhoneNumberInput
            name="physician.phone"
            type="tel"
            label={translate("physicianPhoneNumber")}
            disabled={disabled}
            validate={isValidPhone}
          />
          <PhoneNumberInput
            name="physician.fax"
            type="tel"
            label={translate("physicianFaxNumber")}
            disabled={disabled}
            validate={isValidPhone}
          />
        </div>
      </div>
    </div>
  );
};

export default PhysicianForm;

PhysicianForm.propTypes = {
  physician: PropTypes.object,
  questions: PropTypes.arrayOf(PropTypes.object).isRequired
};
